
<template>
    <div>
        <!-- 标签管理 -->
        <div style="position:absolute;z-index:990;top:-100px;">
            <div class="addiconBox_a">
                <div class="addiconBox_b">
                    <!-- 三种状态弹框内部切换 -->
                    <!-- 新增页面 -->
                    <div v-if="show1">
                        <div class="title_box">
                            {{$t('erp.product.add_label',{defaultValue:'新增标签'})}}
                            <Icon type="chevron-left left-zero addicon-icon" @click="backto1()"></Icon>
                            <Icon type="md-close right-zero addicon-icon" @click="closebox()"></Icon>
                        </div>
                        <div class="body-edit">
                            <vInput v-model="iconName" :placeholder="$t('erp.product.label',{defaultValue:'标签名称'})"></vInput>
                            <ul class="addicon-ul">
                                <li class="addicon-li" v-for="(item,index) in colorsList" :key="index">
                                    <a @click="clickcheckout(index)" >
                                        <div class="addicon-color" :class="colorsList[index].color">
                                            <Icon type="checkmark-round" v-if="index == checkoutindex" class="addcheckout"></Icon>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <vButton theme="primary" :disabled="adddisabled(iconName)" class="width-100per font-14" @click="submit(checkoutindex,'add')">{{$t('global.common.create',{defaultValue:'创建'})}}</vButton>
                    </div>
                    <!-- 列表页面 -->
                    <div v-if="show2">
                        <div class="title_box">
                            <vButton theme="primary" @click="clicknewIcon">{{$t('erp.product.add_label',{defaultValue:'新增标签'})}}</vButton>
                            <Icon type="md-close right-zero addicon-icon" @click="closebox()"></Icon>
                        </div> 
                        <div style="height:152px;">
                            
                            <ul v-if="array.length>0" class="scroll-ul">
                                <li class="tag-list-li" v-for="(item,index) in array" :key="index" @click="toggleShow(item.id,'add')">
                                    <div class="tag-circle-box">
                                        <div class="tag-circle" :class="item.labelColour"></div>
                                    </div>
                                    <div class="tag-name">{{item.labelName}}</div>
                                    <span class="padding-5 margin-right-5" @click="clickedit(item.id,item.labelName,item.labelColour)"><Icon type="md-create" class="addiconedit font-16" style="margin:7px;"></Icon></span>
                                    <span class="padding-5" v-if="item.hide ? true:false"><Icon type="checkmark-round" class="addiconcheck font-16"></Icon></span>
                                </li>
                            </ul>
                            <div v-else class="text-center font-16" style="line-height:125px">{{$t('global.common.nodata',{defaultValue:'暂无数据...'})}}</div>
                        </div>
                    </div>
                    <!-- 展示编辑框 -->
                    <div v-if="show3">
                        <div class="title_box">
                            {{$t('erp.product.edit_label',{defaultValue:'编辑标签'})}}
                            <Icon type="chevron-left left-zero addicon-icon" @click="backto1()"></Icon>
                            <Icon type="md-close right-zero addicon-icon" @click="closebox()"></Icon>
                        </div>
                        <div class="body-edit">
                            <vInput v-model="iconName" :placeholder="$t('global.common.name',{defaultValue:'标签名称'})"></vInput>
                            <ul class="addicon-ul">
                                <li class="addicon-li" v-for="(item,index) in colorsList" :key="index">
                                    <a @click="clickcheckout(index)" >
                                        <div class="addicon-color" :class="colorsList[index].color">
                                            <Icon type="checkmark-round" v-if="index == editcolorindex" class="addcheckout"></Icon>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- <vButton theme="error" class="width-50per font-14" @click="clickdelete">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton> -->
                        <vButton theme="primary" class="width-100per font-14" @click="submit(checkoutindex,'edit')">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
                    </div>
                    <!-- 删除的提示框 -->
                    <div v-if="show4">
                        <div class="title_box">
                            {{$t('erp.product.delete_label',{defaultValue:'删除标签'})}}
                            <Icon type="chevron-left left-zero addicon-icon" @click="backto2()"></Icon>
                            <Icon type="md-close right-zero addicon-icon" @click="closebox()"></Icon>
                        </div>
                        <div class="body-edit" style="height:128px;">
                            {{$t('erp.product.deletelabel_desc',{defaultValue:'确认删除标签？'})}}
                        </div>
                        <vButton theme="error" class="width-100per font-14" @click="deleteIcon">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>

import {
    HttpGetIconList,
    HttpSaveIconOne,
    HttpDeleteIconOne,
} from '@/service/products/allproducts'

export default {
    props:['labelList'],
    data(){
        return {
            titleicon: this.$t('erp.product.new_add', { defaultValue: "新建" }),
            iconName:"",
            colorsList:[
                {color:'ICblue'},
                {color:'ICgreen'},
                {color:'ICdeepgreen'},
                {color:'ICpurple'},
                {color:'ICorange'},
                {color:'ICred'},
            ],
            show1:false,
            show2:true,
            show3:false,
            show4:false,
            checkoutindex:0,
            // listAll:[],
            ary:null,
            array:[],
            globalListId:null,
            editcolorindex:0,
        }
    },
    created(){
        // 请求产品标签的后端数据
        this.getIconsList()
    },
    methods:{
        getIconsList(){
            let arr = this.labelList.split(',')
            HttpGetIconList().then(res=>{
                this.array = res.data
                // console.log(arr,this.array)
                // 对比列表相对应的默认打钩
                this.array.map(item=>{
                    arr.map(json=>{
                        if(item.id == json){
                            item.hide = true
                        }
                    })
                })
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        adddisabled(iconName){
            if(iconName!="") {return false}
            else { return true }
        },
        // 点击li标签,展示打钩标签
        toggleShow(jsonitemid,type){
            // console.log(jsonitemid)
            let obj = this.array.filter(json=>{ return json.id === jsonitemid})[0]; // 找到点击的dom对象

            if(type == 'delete') obj.hide = false; else obj.hide = !obj.hide;  // 向这个对象中添加 hide 属性

            let index = this.array.findIndex(item=> { return item.id === jsonitemid })
            this.$set(this.array, index, obj);  // 把添加完hide 属性的新对象set()进data数据中
            this.$emit('on-checkout',obj)
            // console.log(index,obj.hide)
            // console.log(this.array)
        },
        clickedit(iconid,name,colour){
            this.globalListId = iconid
            this.show3 = true;
            this.show2 = false;
            this.titleicon = this.$t('global.common.edit', { defaultValue: '编辑' });
            this.iconName = name;
            for (let i =0;i<this.colorsList.length;i++){
                if(colour == this.colorsList[i].color){
                    this.editcolorindex = i;
                }
            }
        },
        // 点击新建标签按钮，展示新建的框
        clicknewIcon(){
            this.show1 = true;
            this.show2 = false;
            this.titleicon = this.$t('erp.product.new_add', { defaultValue: "新建" });
        },
        backto1(){
            this.show1 = false;
            this.show3 = false;
            this.show4 = false;
            this.show2 = true;
        },
        backto2(){
            this.show4 = false;
            this.titleicon = this.$t('global.common.edit', { defaultValue: '编辑' });
            this.show3 = true;
        },
        clickdelete(){
            this.show3 = false;
            this.show4 = true;
        },
        clickcheckout(index){
            // console.log(index)
            this.checkoutindex = index
            this.editcolorindex = index
        },
        deleteIcon(){
            this.toggleShow(this.globalListId,'delete')
            HttpDeleteIconOne({
                id:this.globalListId,
            }).then(res=>{
                this.$Message.success(res.message);
                this.array = res.data
                this.backto1()
            },err=>{
                this.errorMessage(err.message);
            })
        },
        submit(nowindex,type){
            if(this.iconName==''){
                this.$Message.error(this.$t('erp.product.name_not_null', { defaultValue: '名称不能为空' }));
                return
            }
            let colorclass = this.colorsList[nowindex].color
            let obj = {
                labelColour:colorclass,
                labelName:this.iconName,
            }

            // 存在这个列表数组
            // 继续新增 
            if(type == 'add'){
                this.array.push(obj)
                HttpSaveIconOne({
                    labelColour:colorclass,
                    labelName:this.iconName
                }).then(res=>{
                    this.array = res.data
                },err=>{
                    this.$Message.error(this.$t('erp.product.name_not_null', { defaultValue: '名称不能为空' }));
                })
                
            }else{
                // 修改列表对象
                // this.$set(this.array,this.globalListindex,obj) 
                //此步骤相当于页面数据已经更新
                HttpSaveIconOne({
                    id:this.globalListId,
                    labelColour:colorclass,
                    labelName:this.iconName
                }).then(res=>{
                    this.array = res.data
                },err=>{
                    this.$Message.error(this.$t('erp.product.name_not_null', { defaultValue: '名称不能为空' }));
                })
            }
            // 点击确定外面列表获取最新标签列表
            this.$emit('on-update')
            this.backto1()
            
        },
        closebox(){
            this.$emit('on-closebox')
        }
    },
    watch:{
        labelList(){
            // console.log(this.labelList)
            this.getIconsList()
        }
    }
}
</script>